exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.substatus-button {\n  padding: 0px;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/views/PAPortal.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"PAPortal.vue","sourcesContent":["\n.substatus-button {\n  padding: 0px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e7f6397","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/PAPortal.vue
// module id = 66En
// module chunks = 1